import PricingCards from './PricingCardsNew'
import {PricingTable} from './PricingTableNew'

interface PricingSectionProps {
  siteCopilotPurchaseRefresh: boolean
  copilotSignupPath: string
  copilotForBusinessSignupPath: string
  copilotForBusinessSignupPathRefresh: string
  copilotEnterpriseSignupPath: string
  copilotContactSalesPath: string
  userHasOrg: boolean
}

export default function PricingSection({
  siteCopilotPurchaseRefresh,
  copilotSignupPath,
  copilotForBusinessSignupPath,
  copilotForBusinessSignupPathRefresh,
  copilotEnterpriseSignupPath,
  copilotContactSalesPath,
  userHasOrg,
}: PricingSectionProps) {
  return (
    <>
      <section id="pricing" className="lp-Section lp-Section--new-pricing-experience lp-Section--pricing">
        <PricingCards
          siteCopilotPurchaseRefresh={siteCopilotPurchaseRefresh}
          copilotSignupPath={copilotSignupPath}
          copilotForBusinessSignupPath={copilotForBusinessSignupPath}
          copilotForBusinessSignupPathRefresh={copilotForBusinessSignupPathRefresh}
          copilotEnterpriseSignupPath={copilotEnterpriseSignupPath}
          copilotContactSalesPath={copilotContactSalesPath}
          userHasOrg={userHasOrg}
        />
      </section>
      <section className="lp-Section lp-Section--new-pricing-experience-table pt-0 pb-5">
        <details>
          <summary>
            <h3>Compare all features</h3>
            <div style={{position: 'relative'}} className="pl-5">
              <span className="icon-collapsed pl-3" />
              <span className="icon-expanded pl-2" />
            </div>
          </summary>
          <PricingTable
            copilotSignupPath={copilotSignupPath}
            copilotForBusinessSignupPath={copilotForBusinessSignupPath}
            copilotContactSalesPath={copilotContactSalesPath}
            footnotesModifier={-1}
          />
        </details>
      </section>
    </>
  )
}

try{ PricingSection.displayName ||= 'PricingSection' } catch {}